module.exports = __webpack_public_path__ + "static/notice-bc9e11351792c548802436ad2550bed0.png";